import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Nav from '../components/Nav/Nav';
import Movie from '../components/Movie/Movie';
import MovieMain from '../components/Main/MovieMain';

const MovieCategory = () => {
  const movieList = [
    { title: 'Trending', slug: 'trending-movies', fetch: 'trending' },
    { title: 'Action', slug: 'action', fetch: 'action' },
    { title: 'Comedy', slug: 'comedy', fetch: 'comedy' },
    { title: 'Horror', slug: 'horror', fetch: 'horror' },
    { title: 'Romance', slug: 'romance', fetch: 'romance' },
    { title: 'Music', slug: 'music', fetch: 'music' },
    { title: 'Drama', slug: 'drama', fetch: 'drama' },
    { title: 'Crime', slug: 'crime', fetch: 'crime' },
    { title: 'Adventure', slug: 'adventure', fetch: 'adventure' },
    { title: 'Fantasy', slug: 'fantasy', fetch: 'fantasy' },
    { title: 'Animation', slug: 'animation', fetch: 'animation' },
    { title: 'History', slug: 'history', fetch: 'history' },
    { title: 'Documentaries', slug: 'documentaries', fetch: 'documentary' },
    { title: 'Kids And Family', slug: 'kids-and-family', fetch: 'kidsAndFamily' },
    { title: 'Mystery', slug: 'mystery', fetch: 'mystery' },
    { title: 'Now Playing', slug: 'now-playing', fetch: 'nowPlaying' },
    { title: 'Popular', slug: 'popular', fetch: 'popular' },
    { title: 'Science Fiction', slug: 'science-fiction', fetch: 'scienceFiction' },
    { title: 'Thriller', slug: 'thriller', fetch: 'thriller' },
    { title: 'War', slug: 'war', fetch: 'war' },
    { title: 'Western', slug: 'western', fetch: 'western' },
    { title: 'Upcoming', slug: 'upcoming-movies', fetch: 'upComing' },
    { title: 'Top Rated', slug: 'top-rated-movies', fetch: 'topRated' },
  ];

  const { movieSlug } = useParams();
  const movie = movieList.filter((mov) => movieSlug === mov.slug)[0];

  const { title, fetch } = movie;

  const fetchApi = useSelector((state) => state[`${fetch}`]);

  return (
    <>
      <Nav />
      <MovieMain />
      <div className="main-movie-section">
        <Movie fetchUrl={fetchApi} title={title} />
      </div>
    </>
  );
};

export default MovieCategory;
